/*
 * An elder wand lying on the desk between the cloche candle and the crystal, drawn by hand at the art's
 * 640 × 360 size the way pixel-art wands are built: a clean 45° shaft two pixels thick inside a crisp
 * dark outline, knobbly nodes along it, a thicker carved handle and a pommel.
 */

type C = [number, number, number];

const OUT: C = [28, 16, 12];
const SHADE: C = [88, 62, 44], BASE: C = [132, 100, 72], LIGHT: C = [182, 150, 112], GLINT: C = [226, 204, 166];
const SHADOW: C = [92, 54, 20];

export function drawWand(x: CanvasRenderingContext2D) {
  const put = (X: number, Y: number, c: C) => { x.fillStyle = `rgb(${c[0]},${c[1]},${c[2]})`; x.fillRect(X, Y, 1, 1); };
  const body = new Map<string, C>();
  const set = (X: number, Y: number, c: C) => body.set(`${X},${Y}`, c);
  // Pommel at the lower left, tip at the upper right: one step right and one up per pixel
  const hx = 102, hy = 318, L = 34;
  const NODES = [12, 18, 24, 29];
  for (let i = 0; i <= L; i++) {
    const X = hx + i, Y = hy - i;
    // Two pixels thick: the upper-left one lit, the lower-right one in shade; one pixel at the very tip
    set(X, Y, i % 5 === 2 ? LIGHT : BASE);
    if (i < L - 2) set(X + 1, Y, SHADE);
    // Handle: a pixel thicker on the lit side, with a carved band
    if (i >= 1 && i <= 8) set(X, Y - 1, i === 4 || i === 5 ? GLINT : LIGHT);
    // Knobbly nodes: a bead swelling out on both sides
    if (NODES.includes(i)) { set(X, Y - 1, GLINT); set(X + 1, Y + 1, SHADE); set(X - 1, Y, LIGHT); set(X + 2, Y, SHADE); }
  }
  // Pommel: a small knob at the end
  set(hx - 1, hy + 1, BASE); set(hx - 1, hy, LIGHT); set(hx, hy + 1, SHADE);
  // Shadow on the desk, a four-way outline, then the wood
  for (const key of body.keys()) { const [X, Y] = key.split(',').map(Number); if (!body.has(`${X + 1},${Y + 2}`)) put(X + 1, Y + 2, SHADOW); }
  for (const key of body.keys()) {
    const [X, Y] = key.split(',').map(Number);
    for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) if (!body.has(`${X + dx},${Y + dy}`)) put(X + dx, Y + dy, OUT);
  }
  for (const [key, c] of body) { const [X, Y] = key.split(',').map(Number); put(X, Y, c); }
}
